import {isPlainObject} from 'rlink-type-utils';
 /**
  * Returns the default iterator for the given object, or
  * Object.entries for plain objects.
  *
  * @param  {IterableCollection} obj
  * @return {Iterator}
  */
export default function iterate (obj) {
  if (!this.isIterable(obj)) {
    throw new Error(`Cannot iterate non-iterable object: ${obj}`);
  }
  if ( obj && Symbol.iterator in obj) {
    return obj[Symbol.iterator]();
  } else if (isPlainObject(obj)) {
    return Object.entries(obj);
  } else {
    return this.NotApplicable;
  }
}



// WEBPACK FOOTER //
// ./lib/rlink-collections/core/iterate.js